import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import {useState, useEffect, useMemo} from "react";
import Modal from '@mui/material/Modal';
import Autocomplete from "@mui/material/Autocomplete";
import {Link} from "react-router-dom";
import MDButton from "../../../../components/MDButton";
import DataTable from "../../../../examples/Tables/DataTable";
import MDSnackbar from "../../../../components/MDSnackbar";
import ClientsService from "../../../../services/clients.service";
import MDBadge from "../../../../components/MDBadge";
import GHIconButton from "../../../../components/GHIconButton";
import TextField from "@mui/material/TextField";
import  { getUserRole} from "../../../../services/auth.service";
import {bookingPartyRoomColumns, partyRoomColumns,} from "../../../../components/Utils/HeaderColumns";
import * as Yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup/dist/yup";
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import {modalStyleClients, modalStyleUser} from "../../../../components/Utils/ModalStyle";
import MDInput from "../../../../components/MDInput";
import PartyRoomService, {
    cancelBookPartyRoom,
    confirmBookPartyRoom,
    getMyPartyRoomBookingAdmin
} from "../../../../services/partyRooms.service";
import React, {useCallback} from 'react'

import Dropzone, {useDropzone} from 'react-dropzone'

// import Dropzone from "dropzone";
const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '30px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out'
};

function UploadImageModal({ open, onClose, bookingId, imageType, existingImages, onUploaded, onError }) {

  const onDrop = useCallback((acceptedFiles) => {
    if (!bookingId || acceptedFiles.length === 0) return;
    const formData = new FormData();
    formData.append("image", acceptedFiles[0], acceptedFiles[0].name);
    formData.append("type", imageType);
    PartyRoomService.uploadPartyRoomBookingImage(bookingId, formData)
      .then((response) => {
        onUploaded(response?.data?.image_url);
      })
      .catch((err) => {
        onError(err);
      });
  }, [bookingId, imageType, onUploaded, onError]);

  const {
    getRootProps,
    getInputProps,
    acceptedFiles,
    isFocused,
    isDragAccept,
    isDragReject
  } = useDropzone({
    onDrop,
    accept: { 'image/*': [] },
    maxFiles: 1,
    multiple: false
  });

  const style = useMemo(() => ({
    ...baseStyle,
    ...(isFocused ? { borderColor: '#2196f3' } : {}),
    ...(isDragAccept ? { borderColor: '#00e676' } : {}),
    ...(isDragReject ? { borderColor: '#ff1744' } : {})
  }), [isFocused, isDragAccept, isDragReject]);

  const files = acceptedFiles.map(file =>
    <li key={file.path}>{file.path}</li>
  );

  return (
    <Modal open={open} onClose={onClose}>
      <MDBox sx={modalStyleClients}>
        <Card>
          <MDBox p={3}>
            <MDTypography variant="h5">Upload Image</MDTypography>
            <MDTypography variant="caption" color="text">
              {imageType === "after" ? "After use image" : "Before use image"}
            </MDTypography>
          </MDBox>

          <MDBox pb={3} px={3}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <div {...getRootProps({ style })}>
                  <input {...getInputProps()} />
                  <p>Drag & drop one image or click to select</p>
                </div>

                <aside>
                  <ul>{files}</ul>
                </aside>
              </Grid>
              {(existingImages || []).length > 0 && (
                <Grid item xs={12}>
                  <MDTypography variant="button" fontWeight="bold" color="dark">
                    Saved Images
                  </MDTypography>
                  <Grid container spacing={2} mt={1}>
                    {(existingImages || []).map((image, index) => (
                      <Grid item xs={12} sm={6} md={4} key={`${image}-${index}`}>
                        <a href={image} target="_blank" rel="noreferrer">
                          <img
                            src={image}
                            alt={`${imageType} party room ${index + 1}`}
                            style={{
                              width: "100%",
                              height: 130,
                              objectFit: "cover",
                              borderRadius: 8,
                              border: "1px solid #e5e7eb",
                            }}
                          />
                        </a>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              )}
            </Grid>
          </MDBox>
        </Card>
      </MDBox>
    </Modal>
  );
}

function BookingNotesModal({ open, onClose, notes, noteText, setNoteText, onSend, canSend }) {
  return (
    <Modal open={open} onClose={onClose}>
      <MDBox sx={modalStyleClients}>
        <Card>
          <MDBox p={3}>
            <MDTypography variant="h5">Booking Notes</MDTypography>
            <MDTypography variant="caption" color="text">
              Notes sent to the resident for this party room booking.
            </MDTypography>
          </MDBox>
          <MDBox px={3} pb={3}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                {(notes || []).length === 0 ? (
                  <MDTypography variant="button" color="text">No notes yet.</MDTypography>
                ) : (
                  (notes || []).map((note) => (
                    <MDBox key={note.id} mb={1.5} p={2} borderRadius="md" sx={{ backgroundColor: "#f7f9fc" }}>
                      <MDTypography variant="caption" color="text">
                        {note.sender} - {note.created_at}
                      </MDTypography>
                      <MDTypography variant="body2" color="dark">
                        {note.note}
                      </MDTypography>
                    </MDBox>
                  ))
                )}
              </Grid>
              {canSend && (
                <>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      multiline
                      minRows={3}
                      label="New note to resident"
                      value={noteText}
                      onChange={(event) => setNoteText(event.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <MDButton color="info" onClick={onSend} disabled={!noteText.trim()}>
                      Send Note
                    </MDButton>
                  </Grid>
                </>
              )}
            </Grid>
          </MDBox>
        </Card>
      </MDBox>
    </Modal>
  );
}

function PartyRoomBookingList() {

    const defaultInputValues = {  partyRoomName: "", area: "", client: null, building: null};

    const [values, setValues] = useState(defaultInputValues);

    const validationSchema = Yup.object().shape({
        partyRoomName: Yup.string()
            .min(6, 'Party Room Name must be at least 6 characters')
            .required('Party Room Name is required'),
        area: Yup.number().required('Party Room area is required'),
    });

    const { register, handleSubmit, formState: { errors  } } = useForm({mode:"all", resolver:yupResolver(validationSchema)});

    const handleChange = (value) => {
        setValues(value);
        setIsValid(validationSchema.isValidSync(values));

    };
 
    const [isValid, setIsValid] = useState(false);

    const [selectedInstance, setSelectedInstance] = useState({});
    const [instanceList, setInstanceList] = useState([]);
    const [buildings, setBuildings] = useState([]);
    const [units, setUnits] = useState([]);
    const [clients, setClients] = useState([]);

    const [openDialog, setOpenDialog] = useState(false);

    const [infoSB, setInfoSB] = useState(false);
    const [errorSB, setErrorSB] = useState(false);
    const openErrorSB = () => setErrorSB(true);
    const closeErrorSB = () => setErrorSB(false);
    const openInfoSB = () => setInfoSB(true);
    const closeInfoSB = () => setInfoSB(false);
    const [errorMessage, setErrorMessage] = useState("");
    const isAdmin = ["super_admin", "admin", "staff"].includes(getUserRole())
    useEffect(() => {
        loadPartyRooms();
    }, [setClients, setBuildings]);



    const [bookingPartyRoomTableData, setBookingPartyRoomTableData] = useState({"columns" : bookingPartyRoomColumns, "rows":[]});
    const [bookings, setBookings] = useState([]);
    const loadPartyRooms = () => {
        setBookingPartyRoomTableData({"columns" : bookingPartyRoomColumns, "rows":[]})
        PartyRoomService.getMyPartyRoomBookingAdmin()
        .then((res) => {
            console.log(res.data);
            const bookingRows = res.data || [];
            setBookings(bookingRows);
            const activeBooking = bookingRows.find((booking) => booking.id.toString() === clickedItemId.toString());
            if (activeBooking) {
                setUploadImages(uploadImageType === "after" ? (activeBooking.after_images || []) : (activeBooking.before_images || []));
            }
            setBookingPartyRoomTableData( {
                "columns": bookingPartyRoomColumns,
                "rows":  bookingRows.map(function(element)  {
                        return {
                                id: element.id,
                                booking_name: element.booking_name,
                                booking_email: element.booking_email,
                                building: element.building,
                                client: element.client,
                                party_room: element.party_room,
                                image_status: <MDBadge badgeContent={element.image_status || "not-uploaded"} color={element.image_status === "not-uploaded" ? "error" : "success"} size="sm" container />,
                                payment_status: <MDBadge badgeContent={element.status === "wait_for_payment" ? "Waiting" : "Accepted"} color={element.status === "confirmed" ? "success" : "dark"} size="sm" container />,
                                status: <MDBadge badgeContent={element.status} color={element.status === "confirmed" ? "success" : element.status === "waiting_for_contract" ? "warning" : "secondary"} size="sm" container />,
                                // date: element.date,
                                book_time: (
                                    <div style={{"textAlign":"center"}}>
                                  <MDTypography variant={"caption"} color={"text"}>{element.date}</MDTypography><br/>
                                      <MDTypography variant={"caption"} color={"dark"}>{element.start_time} - {element.end_time}</MDTypography>
                                    </div>
                                ),
                                start: element.start_time,
                                end: element.end_time,
                                action: (
                                  <div>
                                      <GHIconButton onClick={(event) => handleClickItem(event, element)} id={element.id} action={"upload_before_image"}
                                                    rowName={ element.booking_name} title={"Upload Before Image"} color={"dark"}
                                                    style={{"display": element.status === "confirmed" || element.status === "canceled" ? "none": "flex"}}
                                                    icon={"camera_alt"} size={"medium"} />
                                      <GHIconButton onClick={(event) => handleClickItem(event, element)} id={element.id} action={"upload_after_image"}
                                                    rowName={ element.booking_name} title={"Upload After Image"} color={"info"}
                                                    style={{"display": element.status === "confirmed" ? "flex": "none"}}
                                                    icon={"add_a_photo"} size={"medium"} />
                                      <GHIconButton onClick={(event) => handleClickItem(event, element)} id={element.id} action={"accept"}
                                                    rowName={ element.booking_name} title={"Accept"} color={"success"}
                                                    style={{"display": element.status === "canceled" || element.status === "confirmed" ? "none": "flex"}}
                                                    icon={"done"} size={"medium"} />
                                      <GHIconButton onClick={(event) => handleClickItem(event, element)} id={element.id} action={"note"}
                                                    rowName={ element.booking_name} title={"Notes"} color={"warning"}
                                                    icon={"sticky_note_2"} size={"medium"} />
                                      <GHIconButton onClick={(event) => handleClickItem(event, element)} id={element.id} action={"cancel"}
                                                    rowName={ element.booking_name} title={"Cancel"} color={"error"}
                                                    style={{"display": element.status === "canceled" || element.is_past ? "none": "flex"}}
                                                    icon={"close"} size={"medium"} />
                                  </div>
                                ),
                            }
                    }),
            })

        })
        .catch((error) => {
          console.log(error);
        });
    }

    const [clickedItemId, setClickedItemId] = useState(0);
    const [openInsertModel, setOpenInsertModel] = useState(false);
    const [openUserModel, setOpenUserModel] = useState(false);
    const [editMode, setEditMode] = useState(false);

    const loadSinglePartyRoom = (id) =>{
        // alert(clickedItemId)
        if (id > 0){
             PartyRoomService.getPartyRoom(id)
            .then((result)=>{
                // loadBuilding(result.data.client.id)
                setValues({
                    id: id,
                    partyRoomName: result.data.name,
                    area: result.data.height,
                    // weight: result.data.weight,
                    client: result.data.client?.id ? {id:result.data.client.id, client_name:result.data.client.client_name || result.data.client.name} : null,
                    building: result.data.building_id ? {id:result.data.building.id, name:result.data.building.building_name} : null,
                });
                setOpenInsertModel(true);
            }).catch((reason) =>{
                setErrorMessage(reason.response.data.status.toString());
                openErrorSB();
            });
        }

    };

    const [dialogTitle, setDialogTitle] = useState("")
    const [dialogBody, setDialogBody] = useState("")
    const [cancelReason, setCancelReason] = useState("")
    const handleOpen = (event, model) => {
        switch (model){
            case "insert":
                setEditMode(false);
                setOpenInsertModel(true);
                break;
            case "edit":
                setEditMode(true);
                loadSinglePartyRoom(event.target.id);
                break;
            case "cancel" :
                setDialogTitle("Cancel Booking")
                setDialogBody("Are you sure to Cancel this party room booking?")
                setCancelReason("")
                handleOpenDialog(model);
                break;
            case "change_status":
                handleOpenDialog(model);
                break;
            case "accept":
                setDialogTitle("Approve Booking")
                setDialogBody("Are you sure to approve this party room booking?")
                handleOpenDialog(model);
                break;
        }
    }
    const handleClose = (model) => {
        switch (model){
            case "insert":
                setOpenInsertModel(false);
                break;
            case "user":
                setOpenUserModel(false);
                break;
        }
    }


    const [dialogAction, setDialogAction] = useState("")
    const handleOpenDialog = (action) => {
        setOpenDialog(true);
        setDialogAction(action)
    }
    const handleCloseDialog = () => setOpenDialog(false);

    const handleAgreeDeleteDialog = () => {
        const getErrorMessage = (err) => {
            if (typeof err?.response?.data === "string") return err.response.data;
            if (err?.response?.data?.status) return err.response.data.status.toString();
            if (err?.response?.data?.message) return err.response.data.message.toString();
            if (err?.message) return err.message;
            return "Unknown error";
        };

        if (dialogAction === "cancel") {
            if (!cancelReason.trim()) {
                setErrorMessage("Cancellation reason is required");
                openErrorSB();
                return;
            }
            PartyRoomService.cancelBookPartyRoom(clickedItemId, cancelReason.trim())
                .then((response) => {
                    openInfoSB();
                    window.location.reload();
                })
                .catch((err) => {
                    console.log(err);
                    setErrorMessage(getErrorMessage(err));
                    openErrorSB();
                });

        }else if(dialogAction === "accept"){

            PartyRoomService.confirmBookPartyRoom(clickedItemId)
                .then((response) => {
                    openInfoSB();
                    window.location.reload();
                })
                .catch((err) => {
                    console.log(err);
                    setErrorMessage(getErrorMessage(err));
                    openErrorSB();
                });
        }
    }

       const loadUnit = (building_id) => {
        ClientsService.getBuildingUnits(building_id)
        .then((res) => {
            console.log(res.data);
            setUnits(res.data);
            // loadProvince(res.data[0]);
        })
        .catch((error) => {
            console.log(error);
        });
    }


     const loadBuilding = (client_id) => {
            ClientsService.getClientsBuilding(client_id)
            .then((res) => {
                console.log(res.data);
                setBuildings(res.data);
                if(res.data[0].length > 0){
                    loadUnit(res.data[0].id);
                }
            })
            .catch((error) => {
                console.log(error);
            });
        }


    const [openUploadImage, setOpenUploadImage] = useState(false)
    const [uploadImageType, setUploadImageType] = useState("before")
    const [uploadImages, setUploadImages] = useState([])
    const [openNotes, setOpenNotes] = useState(false)
    const [bookingNotes, setBookingNotes] = useState([])
    const [noteText, setNoteText] = useState("")
    const openImageModal = () => setOpenUploadImage(true)
    const closeImageModal = () => setOpenUploadImage(false)
    const closeNotesModal = () => setOpenNotes(false)
    const getErrorMessage = (err) => {
        if (typeof err?.response?.data === "string") return err.response.data;
        if (err?.response?.data?.status) return err.response.data.status.toString();
        if (err?.response?.data?.message) return err.response.data.message.toString();
        if (err?.message) return err.message;
        return "Unknown error";
    };
    const loadBookingNotes = (bookingId) => {
        setBookingNotes([]);
        PartyRoomService.getPartyRoomBookingNotes(bookingId)
            .then((response) => setBookingNotes(response.data || []))
            .catch((err) => {
                setErrorMessage(getErrorMessage(err));
                openErrorSB();
            });
    };
    const sendBookingNote = () => {
        if (!clickedItemId || !noteText.trim()) return;
        PartyRoomService.sendPartyRoomBookingNote(clickedItemId, noteText.trim())
            .then(() => {
                setNoteText("");
                openInfoSB();
                loadBookingNotes(clickedItemId);
                loadPartyRooms();
            })
            .catch((err) => {
                setErrorMessage(getErrorMessage(err));
                openErrorSB();
            });
    };
    function handleClickItem(elem, row = null) {
        const target = elem.currentTarget || elem.target?.closest?.("[action]") || elem.target;
        let actionToDo = target?.getAttribute("action");
        let rowName = target?.getAttribute("rowname") || row?.booking_name || "";
        let rowId = row?.id || target?.id || target?.getAttribute("id");
        if (!actionToDo || !rowId) return;
        const selectedBooking = row || bookings.find((booking) => booking.id.toString() === rowId.toString());
        // alert(rowId)
        setClickedItemId(rowId);
        setSelectedClientTitle(rowName);
        switch (actionToDo) {
            case "edit":
                handleOpen(elem,"edit");
                break;
            case "change_status":
                handleOpen(elem,"change_status");
                break;
            case "accept":
                handleOpen(elem,"accept");
                break;
            case "upload_before_image":
                setUploadImageType("before");
                setUploadImages(selectedBooking?.before_images || []);
                openImageModal()
                break;
            case "upload_after_image":
                setUploadImageType("after");
                setUploadImages(selectedBooking?.after_images || []);
                openImageModal()
                break;
            case "note":
                setNoteText("");
                loadBookingNotes(rowId);
                setOpenNotes(true);
                break;
            case "cancel":
                handleOpen(elem,"cancel");
                break;
        }
    }

    const [userTableData, setUserTableData] = useState({});
    const [selectedClientTitle, setSelectedClientTitle] = useState("");
    const renderDialog = () => {
        return (
            <Dialog
                open={openDialog}
                keepMounted
                onClose={handleCloseDialog}
                aria-describedby="alert-dialog-slide-description">
                <DialogTitle><Icon color={"success"} >check</Icon>{ dialogTitle}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                  {dialogBody}
              </DialogContentText>
              {dialogAction === "cancel" && (
                <TextField
                  fullWidth
                  multiline
                  minRows={3}
                  label="Cancellation reason"
                  value={cancelReason}
                  onChange={(event) => setCancelReason(event.target.value)}
                  sx={{ mt: 2 }}
                />
              )}
            </DialogContent>
            <DialogActions>
              <MDButton onClick={handleCloseDialog} >Disagree</MDButton>
              <MDButton onClick={handleAgreeDeleteDialog}  size={"large"}  color={"info"}  >Agree</MDButton>
            </DialogActions>
          </Dialog>
        )
    }
    const saveDataClicked = (e) =>{
        e.preventDefault();
        if(isValid){
            let dataToSend = {
                "client_id": values.client?.id?.toString() || null,
                "building_id": values.building?.id || null,
                "name": values.partyRoomName,
                "area": values.area,
                "drinks": values.drinks,
                "late_hours": values.late_hours,
                "max_people_number": values.max_people_number,
            }
            if(editMode){
                PartyRoomService.updatePartyRoom(values.id, dataToSend)
                    .then((response) =>{
                        console.log(response);
                        openInfoSB();
                        window.location.reload();
                    })
                    .catch((err) => {
                        console.log(err);
                        setErrorMessage(err.response.data.status.toString());
                        openErrorSB();
                    });
            }else{
                PartyRoomService.insertPartyRoom(dataToSend)
                    .then((response) =>{
                        console.log(response);
                        openInfoSB();
                        window.location.reload();
                    })
                    .catch((err) => {
                        console.log(err);
                        setErrorMessage(err.response.data.status.toString());
                        openErrorSB();
                    });
            }

        }
        // handleClose();
    }

    const renderSB = (
        <div>
            <MDSnackbar
              color="success"
              icon="notifications"
              title="Amenity System"
              content="Your data saved successfully"
              dateTime=""
              open={infoSB}
              onClose={()=>setInfoSB(false)}
              close={()=>setInfoSB(false)}  />

            <MDSnackbar
              color="error"
              icon="error"
              title="Amenity System"
              content={errorMessage}
              dateTime=""
              open={errorSB}
              onClose={()=>setErrorSB(false)}
              close={()=>setErrorSB(false)}/>
        </div>
    );  

    const renderInsertModal = () => {
        return <Modal open={openInsertModel} onClose={(e)=>{handleClose("insert")}} color={"warning"} >
          <MDBox sx={modalStyleClients}>
            <Card id="basic-info" sx={{ overflow: "visible" }}>
              <MDBox p={3}>
                <MDTypography variant="h5" >{editMode ? "Edit Party Room": "Insert New Party Room"}</MDTypography>
              </MDBox>
              <MDBox component="form" pb={3} px={3}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={12}>
                    <Autocomplete
                          required
                          options={ clients}
                          value={values.client}
                          clearIcon={false}
                          clearOnBlur={false}
                          contentEditable={false}
                          getOptionLabel={(option) => option.client_name ?? "loading...."}
                          onChange={(event,value) => {
                            setValues({ ...values, client: value, building: null });
                            if (value?.id) {
                                loadBuilding(value.id);
                            } else {
                                setBuildings([]);
                            }
                          }}
                          renderInput={(params) => (
                            <MDInput {...params}
                                        error={!!errors.client}
                                        helperText={errors.client?.message}
                                        label="Client"
                                        InputLabelProps={{ shrink: true }}
                                        {...register("client")}/>
                          )}
                        />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Autocomplete
                          options={buildings}
                          value={values.building}
                          clearOnBlur={false}
                          contentEditable={false}
                          getOptionLabel={(option) => option?.name ?? ""}
                          onChange={(event,value) => {
                              // alert(value);
                            handleChange({ ...values, building: value });
                          }}
                          renderInput={(params) => (
                            <MDInput {...params}
                                        error={!!errors.building}
                                        helperText={errors.building?.message}
                                        label="Building (optional)"
                                        InputLabelProps={{ shrink: true }}
                                        {...register("building")} />
                          )}
                        />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                          fullWidth
                          required
                          error={!!errors.partyRoomName}
                          helperText={errors.partyRoomName?.message}
                          value={values.partyRoomName}
                          {...register("partyRoomName")}
                          onChange={(event) => {
                            handleChange({ ...values, partyRoomName: event.target.value })
                          }}
                        label="Party Room Name"
                        placeholder="Right Building Party Room"  />
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <TextField
                          fullWidth
                          required
                          type={"number"}
                          min={0}
                          error={!!errors.area}
                          helperText={errors.area?.message}
                          value={values.area}
                          {...register("area")}
                          onChange={(event) => {
                            handleChange({ ...values, weight: event.target.value })
                          }}
                          label="Area (Meter)"
                          placeholder="120"  />
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <TextField
                          fullWidth
                          required
                          type={"number"}
                          min={0}
                          error={!!errors.area}
                          helperText={errors.area?.message}
                          value={values.area}
                          {...register("area")}
                          onChange={(event) => {
                            handleChange({ ...values, weight: event.target.value })
                          }}
                          label="Area (Meter)"
                          placeholder="120"  />
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <TextField
                          fullWidth
                          required
                          type={"number"}
                          min={0}
                          error={!!errors.area}
                          helperText={errors.area?.message}
                          value={values.area}
                          {...register("area")}
                          onChange={(event) => {
                            handleChange({ ...values, weight: event.target.value })
                          }}
                          label="Area (Meter)"
                          placeholder="120"  />
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <TextField
                          fullWidth
                          required
                          type={"number"}
                          min={0}
                          error={!!errors.area}
                          helperText={errors.area?.message}
                          value={values.area}
                          {...register("area")}
                          onChange={(event) => {
                            handleChange({ ...values, weight: event.target.value })
                          }}
                          label="Area (Meter)"
                          placeholder="120"  />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <MDButton disabled={!isValid} color={"info"} size={"large"} onClick={saveDataClicked} >Save Data</MDButton>
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
          </MDBox>
        </Modal>
    };

    const renderUserListModal = () => {

        return <Modal open={openUserModel} onClose={(e)=>{handleClose("user")}} color={"warning"} >
          <MDBox sx={modalStyleUser}>
            <Card id="basic-info" sx={{ overflow: "visible" }}>
              <MDBox p={3}>
                <MDTypography variant="h5">{selectedClientTitle} Client Member's List</MDTypography>
              </MDBox>
              <MDBox component="form" pb={3} px={3}>
                 <Grid pb={2}  >
                    <MDButton color={"info"} size={"large"} variant={"gradient"}
                              to={"/users/insert?client_id=" + clickedItemId} component={Link} target={"_blank"}  >
                        <Icon>add</Icon>Add Member To {selectedClientTitle}
                    </MDButton>
                 </Grid>
                <Grid container spacing={3}>

                    <DataTable table={userTableData} showTotalEntries canSearch />
                </Grid>
              </MDBox>
            </Card>
          </MDBox>
        </Modal>
    };

    const renderPartyRoomList = () => {
        return(
            <MDBox my={3}>
              {renderSB}
              {renderInsertModal()}
              {renderUserListModal()}
              {renderDialog()}
              <UploadImageModal
                open={openUploadImage}
                onClose={closeImageModal}
                bookingId={clickedItemId}
                imageType={uploadImageType}
                existingImages={uploadImages}
                onUploaded={(imageUrl) => {
                    if (imageUrl) {
                        setUploadImages((images) => [...images, imageUrl]);
                    }
                    openInfoSB();
                    loadPartyRooms();
                }}
                onError={(err) => {
                    const message = err?.response?.data?.status || err?.response?.data?.message || err?.message || "Image upload failed";
                    setErrorMessage(message);
                    openErrorSB();
                }}
              />
              <BookingNotesModal
                open={openNotes}
                onClose={closeNotesModal}
                notes={bookingNotes}
                noteText={noteText}
                setNoteText={setNoteText}
                onSend={sendBookingNote}
                canSend={true}
              />
              {/*<MDBox  display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>*/}
                  {/*<MDButton variant="gradient" color="warning" size="large"*/}
                  {/*          disabled={selectedInstance.id === ""} onClick={(e) => {handleOpen(e,"insert")}}>*/}
                  {/*  new Party Room*/}
                  {/*</MDButton>*/}
                  {/*<MDBox display={isAdmin ? "flex": "none"} >*/}
                  {/*    <Autocomplete*/}
                  {/*        sx={{ width: 300 }}*/}
                  {/*        value={selectedInstance}*/}
                  {/*        options={instanceList}*/}
                  {/*        getOptionLabel={(option) => option.name ?? "--loading"}*/}
                  {/*        onChange={(event,value) => {*/}
                  {/*          setSelectedInstance(value);*/}
                  {/*          loadClients(value.id);*/}
                  {/*        }}*/}
                  {/*        renderInput={(params) =>*/}
                  {/*            <TextField  {...params} label={"Instance"} />*/}
                  {/*        }*/}
                  {/*      />*/}
                  {/*</MDBox>*/}
              {/*</MDBox>*/}
              <Card>
                    <DataTable
                        showTotalEntries={true}
                        table={bookingPartyRoomTableData}
                        entriesPerPage={false}
                        canSearch />
              </Card>
            </MDBox>
        )
    };

    return (
        <DashboardLayout>
          <DashboardNavbar />
            {renderPartyRoomList()}
          <Footer />
        </DashboardLayout>
    );


}

export default PartyRoomBookingList;
